// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as AuthStore$PorterinFeature from "../../../../containers/login/domain/store/AuthStore.mjs";
import * as NextImage$PorterinFeature from "../../../../ui/components/NextImage.mjs";
import * as CityContext$PorterinFeature from "../../../../contexts/city-context/CityContext.mjs";
import * as HomeStoreEn$PorterinFeature from "../../../../containers/home/domain/store/HomeStoreEn.mjs";
import * as HeaderModuleScss from "../styles/Header.module.scss";
import * as MobileMenuCmp$PorterinFeature from "./MobileMenuCmp.mjs";
import * as PublishEventsHelper$PorterinFeature from "../../../core/helpers/PublishEventsHelper.mjs";

var styles = HeaderModuleScss;

function HeaderMobileMenuSection(Props) {
  var menu_content = Props.menu_content;
  var citySelectedContext = CityContext$PorterinFeature.useCitySelectedContext(undefined);
  var match = React.useState(function () {
        return false;
      });
  var set_is_mobile_menu_open = match[1];
  var is_mobile_menu_open = match[0];
  return React.createElement(React.Fragment, undefined, React.createElement("div", {
                  className: styles["menu-icon"],
                  onClick: (function (param) {
                      Curry._1(set_is_mobile_menu_open, (function (prev) {
                              return !prev;
                            }));
                      PublishEventsHelper$PorterinFeature.publishEvents(citySelectedContext.category, AuthStore$PorterinFeature.Header.ga_mobile_menu_open, undefined);
                    })
                }, React.createElement(NextImage$PorterinFeature.make, {
                      src: menu_content.open_icon.path,
                      height: 20.0,
                      width: 20.0,
                      quality: 100.0,
                      alt: menu_content.open_icon.alt_text
                    })), React.createElement("div", {
                  className: styles["mobile-menu"]
                }, React.createElement("div", {
                      className: is_mobile_menu_open ? styles["mobile-menu-overlay"] : "",
                      onClick: (function (param) {
                          Curry._1(set_is_mobile_menu_open, (function (param) {
                                  return false;
                                }));
                          PublishEventsHelper$PorterinFeature.publishEvents(citySelectedContext.category, HomeStoreEn$PorterinFeature.ga_header_hamburger_action, undefined);
                        })
                    }), React.createElement("div", {
                      className: "" + styles["mobile-menu-component"] + " " + (
                        is_mobile_menu_open ? styles.active : ""
                      ) + ""
                    }, React.createElement(MobileMenuCmp$PorterinFeature.make, {
                          set_is_mobile_menu_open: set_is_mobile_menu_open,
                          data: menu_content
                        }))));
}

var Link;

var make = HeaderMobileMenuSection;

export {
  styles ,
  Link ,
  make ,
}
/* styles Not a pure module */
